import React from "react";
import {
  Box,
  Avatar,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm"; // Для таблиц, ссылок и т.д.

export default function ChatMessage({ message }) {
  const isUser = message.role === "user";
  const isLoading = message.role === "model" && message.text === "";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isUser ? "flex-end" : "flex-start",
        width: "100%",
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1.5,
          maxWidth: "80%",
          alignItems: "flex-start",
          order: isUser ? 2 : 1, // Аватар справа для юзера
        }}>
        {/* --- Аватар --- */}
        <Avatar
          sx={{
            bgcolor: isUser ? "primary.main" : "secondary.main",
            width: 32,
            height: 32,
            mt: 0.5,
          }}>
          {isUser ? (
            <PersonIcon fontSize="small" />
          ) : (
            <AutoAwesomeIcon fontSize="small" />
          )}
        </Avatar>

        {/* --- Тело сообщения --- */}
        <Paper
          elevation={1}
          sx={{
            p: 1.5,
            bgcolor: isUser ? "primary.main" : "background.paper", // 1. ИЗМЕНЕНО: на 'primary.main' (темнее)
            color: isUser ? "common.white" : "text.primary", // 2. ИСПРАВЛЕНИЕ: Белый текст для юзера
            borderRadius: "12px",
            // Стили для markdown (теперь с белым текстом)
            "& p": { m: 0, color: isUser ? "common.white" : "text.primary" },
            "& ol, & ul": {
              m: 0,
              pl: 2.5,
              color: isUser ? "common.white" : "text.primary",
            },
            "& code": {
              backgroundColor: isUser ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0.05)",
              color: isUser ? "common.white" : "text.primary",
              padding: "2px 4px",
              borderRadius: "4px",
            },
            "& pre": {
              backgroundColor: isUser ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0.08)",
              color: isUser ? "common.white" : "text.primary",
              padding: 1,
              borderRadius: "4px",
              overflowX: "auto",
            },
          }}>
          {/* --- Превью изображения (если есть) --- */}
          {message.image && (
            <Box
              component="img"
              src={message.image}
              alt="upload-preview"
              sx={{
                width: "100%",
                maxWidth: 200,
                height: "auto",
                borderRadius: 1.5,
                mb: 1,
              }}
            />
          )}

          {/* --- Текст сообщения --- */}
          {isLoading ? (
            <CircularProgress size={20} color="inherit" /> // 'inherit' возьмет белый цвет
          ) : (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {message.text}
            </ReactMarkdown>
          )}
        </Paper>
      </Box>
    </Box>
  );
}
